module.exports = __webpack_public_path__ + "524e650ec19c3710c5508e1c166b2055.svg";